import React from 'react';
import PropTypes from 'prop-types';
import { Container, VStack, Text, Flex, GridItem } from '@chakra-ui/react';

import { generateSectionId } from '@repo/ui-components/dept/utils/generateSectionId';
import Image from '@repo/ui-components/tailwind/Image';
import { DeptGrid } from '@repo/ui-components/dept/design-system';
import Link from '@repo/ui-components/tailwind/Link';

export default function AssetCardRowFourUp({ block }) {
  const { cards } = block;

  return (
    <Container {...generateSectionId(block)} py={10}>
      <DeptGrid>
        {cards
          ?.filter(card => card.title)
          .map(card => (
            <GridItem
              key={card._key}
              minH="5rem"
              colSpan={{
                base: 6,
                xl: 3,
              }}
            >
              <Flex
                as={Link}
                link={card.link}
                transition="filter 0.2s ease-in-out"
                _hover={{ filter: card?.link ? 'brightness(.95)' : 'none' }}
                _focus={{ filter: card?.link ? 'brightness(.95)' : 'none' }}
                align="center"
                p={4}
                gap={4}
                bg="neutral.50"
                borderRadius="lg"
                h="full"
              >
                {card?.icon?.asset?.url && (
                  <Image sanityImage={card?.icon} width="1.5rem" />
                )}
                <VStack align="flex-start">
                  {card?.title && <Text>{card.title}</Text>}
                  {card?.copy && (
                    <Text textStyle="caption" color="typography.light">
                      {card.copy}
                    </Text>
                  )}
                </VStack>
              </Flex>
            </GridItem>
          ))}
      </DeptGrid>
    </Container>
  );
}

AssetCardRowFourUp.propTypes = {
  block: PropTypes.shape({
    _key: PropTypes.string,
    _type: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string,
        title: PropTypes.string,
        copy: PropTypes.string,
        icon: PropTypes.shape({
          asset: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
      })
    ),
  }).isRequired,
};
